import { addLocale } from 'primereact/api';
import ru from './languages/ru.json';
import en from './languages/en.json';
export var setLocalizations = function () {
    // Add Russian language
    addLocale('ru', ru);
    // Add English language
    addLocale('en', en);
};
